var DFTlrd = DFTlrd || {};

DFTlrd.SilverSponsorSwiper = function() {

    var _swiper;

    var _init = function() {
        let el = $('.swiper--silver-sponsors');
        _swiper = new Swiper(el[0], {
            speed: 500,
            loop: true,
            freemode: true,
            autoplay : {
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
                delay: 1000
            },
            slidesPerView: 2.5,
            spaceBetween: 20,
            breakpoints: {
                576: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                992: {
                    slidesPerView: 6,
                    spaceBetween: 40
                },
                1200: {
                    slidesPerView: 6,
                    spaceBetween: 40
                },
                1400: {
                    slidesPerView: 8,
                    spaceBetween: 40
                },
                1920: {
                    slidesPerView: 10,
                    spaceBetween: 40
                },
            }
        });
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
    };

}();

$(function() {
    DFTlrd.SilverSponsorSwiper.init();
});
